// i18n area 'common' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO, che è la lingua SORGENTE (regola
// ratificata 2026-08-03). L'islandese è la lingua più nativizzante del canone:
// klasi (cluster), hnútur (nodo), geymsla (storage), sniðmát (template),
// skyndimynd (snapshot), skyndiminni (cache), mælaborð (dashboard), verk (task);
// restano invariati i termini di contract e i kind: scope, realm, fabric, IPAM,
// registry, repository, overlay, pool, digest, break-glass, Markdown, i token di
// brand (TVirt©, TVStor, Trantor, Ceph). Sidecar: ../meta/common.is-IS.meta.json.
import type { enUS } from './common'

export const isIS: typeof enUS = {
  nav: {
    home: 'Heim',
    vms: 'Sýndarvélar',
    templates: 'Sniðmát',
    importVms: 'Flytja inn VM',
    containers: 'Gámar',
    containersApps: 'Öpp',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-myndir',
    containersOciRegistries: 'OCI-registries',
    containersCtTemplates: 'CT-sniðmát',
    networkServices: 'Netþjónustur',
    firewall: 'Eldveggur',
    checkpoints: 'Checkpoint',
    backup: 'Öryggisafritun',
    monitoring: 'Vöktun',
    cluster: 'Klasi',
    clusterSettings: 'Heildarstillingar',
    clusterNodes: 'Hnútar',
    clusterDevices: 'USB- og PCIe-auðlindir',
    clusterFederation: 'Samband',
    network: 'Net',
    overlayNetworks: 'Overlay-net',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Geymsla',
    data: 'Gögn',
    storages: 'Geymslur',
    hci: 'Ofursamleitni',
    ceph: 'Ceph',
    system: 'Kerfi',
    tasks: 'Verk',
    events: 'Atburðir',
    audit: 'Úttekt',
    diagnostics: 'Greining',
    notifications: 'Tilkynningar',
    proximity: 'TVirt Proximity',
    users: 'Notendur og hópar',
    groups: 'Hópar',
    mfa: 'MFA',
    realms: 'Realm og SSO',
    rbac: 'Hlutverk og heimildir',
    credentials: 'Aðgangsupplýsingar',
    scopes: 'Scope',
    tags: 'Merki',
    explorer: 'Skoða',
    licensing: 'Leyfi',
    information: 'Upplýsingar'
  },
  mode: {
    light: 'Ljóst',
    dark: 'Dökkt',
    system: 'Kerfi',
    tooltip: 'Þema'
  },
  language: {
    tooltip: 'Tungumál'
  },
  langRegion: {
    europe: 'Evrópa',
    northAmerica: 'Norður-Ameríka',
    southAmerica: 'Suður-Ameríka',
    asia: 'Asía'
  },
  notFound: {
    title: 'Síða fannst ekki',
    body: 'Þetta vistfang samsvarar engri síðu í TVirt — hún kann að hafa færst við uppfærslu, eða hlekkurinn er gamall.',
    backHome: 'Aftur á Heim'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Allur klasinn',
    noChildren: 'Ekkert undir-scope hér',
    recursive: 'Taka afkomendur með',
    collapse: 'Fella scope-spjaldið saman',
    openPicker: 'Skoða scope',
    up: 'Fara upp um stig',
    countTooltip: '{direct} í þessu scope · {total} með afkomendum'
  },
  search: {
    tooltip: 'Leita (⌘K)',
    placeholder: 'Leita að VM, netum, geymslum…',
    empty: 'Engar niðurstöður',

    // Round command palette (#221, ratifica 2026-08-06): intestazioni dei
    // gruppi, i tipi fuori dal censimento explorer, il vocabolario tasti e i
    // verbi del gruppo Azioni.
    groups: {
      recent: 'Nýlegt',
      shortcuts: 'Flýtileiðir',
      actions: 'Aðgerðir',
      goTo: 'Fara í'
    },
    kind: {
      catalog: 'Katalógur',
      scope: 'Scope',
      node: 'Hnútur'
    },
    footer: {
      navigate: 'flakka',
      open: 'opna',
      close: 'lokar'
    },
    actions: {
      createVm: 'Búa til VM…',
      uploadIso: 'Hlaða upp ISO…',
      clusterSettings: 'Stillingar klasans',
      consoleOf: 'Fara í stjórnskjá {name}'
    }
  },
  stub: {
    containersSummary: 'Forrit og kerfisgámar (CT), ásamt OCI-myndum, registry og sniðmátum þeirra — stjórnað við hlið VM-anna þinna.',
    sectionSummary_vms: 'Sýndarvélar og sniðmát þeirra — lífsferill, skyndimyndir, flutningur og stjórnskjár.',
    sectionSummary_storages: 'Geymslurnar þar sem diskar, myndir og lýsigögn VM-anna búa.',
    sectionSummary_catalogs: 'Heimili skráar-artefakta klasans: ISO-myndir, CT- og VM-sniðmát og OCI-söfn, skipulögð í katalóga.',
    sectionSummary_overlay: 'VXLAN overlay-net milli hnúta klasans.',
    sectionSummary_fabric: 'Yfirlit yfir efnislega netið — skiptar, port, LAGG og rökræn net.',
    sectionSummary_ipam: 'Vistfangaúthlutunin leidd af fabric- og overlay-netunum: hver heldur hverju vistfangi.',
    sectionSummary_services: 'DHCP- og DNS-þjónar leiddir af netskránni.',
    sectionSummary_ceph: 'Ceph-klasar reknir á TVirt-hnútum.',
    sectionSummary_hci: 'Ofursamleitin geymslutækni á TVirt-hnútum.',
    sectionSummary_cluster: 'Hnútar, aðild og stillingar klasans.',
    containers: 'Kerfisgámar eru á vegvísinum — þessi hluti mun hýsa þá.',
    containersApps: 'Forrit í gámum eru á vegvísinum — þetta svæði mun hýsa þau.',
    containersPods: 'Pods hópa saman gáma sem deila neti og gagnageymslum — tilvikin eru öppin.',
    containersCt: 'Kerfisgámar (CT) eru á vegvísinum — þetta svæði mun hýsa þá.',
    multiscsi: 'TVStor MultiSCSI er á vegvísinum — þetta svæði mun hýsa það.',
    clusterFederation: 'Samband milli TVirt-klasa er á vegvísinum — þetta svæði mun hýsa það.',
    containersOciImages: 'OCI-myndir eru á vegvísinum — þetta svæði mun hýsa þær.',
    containersOciRegistries: 'OCI-registries eru á vegvísinum — þetta svæði mun hýsa þau.',
    containersCtTemplates: 'CT-sniðmát eru á vegvísinum — þetta svæði mun hýsa þau.',
    importVms: 'Innflutningstólin fyrir ESXi og Proxmox koma hér: umbreyting gesta og fjöldaflutningur inn í TVirt.',
    backup: 'Innbyggð öryggisafritun kemur með 6.2: content-addressed og tvítakalaus repository, CBT-stigvaxandi afrit, óbreytanleikagluggar og speglun repo-í-repo.',
    monitoring: 'Mælaborð fyrir samkeppni um auðlindir yfir allan klasann (cpu.ready, PSI-þrýstingur, innbyggðar viðvaranir) eru væntanleg — í dag búa sömu mælingar í nánari upplýsingum hverrar VM.'
  },
  home: {
    welcome: 'Þú ert innskráð(ur) sem: {name}',
    subtitle: 'Hér er TVirt-klasinn þinn í fljótu bragði.',
    loadError: 'Ekki tókst að sækja yfirlitið — næst samband við TVirt-bakendann?',
    health: {
      ok: 'Allt í lagi',
      warning: 'Aðvörun',
      critical: 'Alvarleg vandamál'
    },
    reason: {
      'node-down': '{subject} er slökktur',
      'node-stale': '{subject} hefur ekki látið í sér heyra um hríð',
      'node-maintenance': '{subject} í viðhaldi',
      'tasks-failed': {
        one: '{n} verk mistókst síðustu 24 klst.',
        other: '{n} verk mistókust síðustu 24 klst.'
      },
      'storage-degraded': 'geymsla {subject} skert',
      'storage-error': 'geymsla {subject} í villuástandi',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'ekki næst í gagnageymslu klasans',
      'license-absent': 'ekkert leyfi — nýjar VM geta ekki ræst',
      'license-expired': 'leyfið er útrunnið — nýjar VM geta ekki ræst',
      'license-exceeded': 'farið yfir leyfismörk — nýjar VM geta ekki ræst',
      'failover-reserve-eroded': 'failover-forðinn er næstum uppurinn',
      'failover-reserve-exhausted': 'failover-forðinn er uppurinn — nýjar VM geta ekki ræst',

      'oci-cache-nearly-full': 'OCI-skyndiminnið næstum fullt á {subject} — digest er úthýst handvirkt',
      'oci-cache-full': 'OCI-skyndiminnið fullt á {subject} — ekkert pull tekst fyrr en þú úthýsir digest-um',
      'config-replica-empty': 'stillingaafrit á {subject} er TÓMT — hnúturinn hefur enga klasastillingu fyrr en afritun tekst',
      'config-replica-stalled': 'stillingaafritun á {subject} er stopp — staðbundna afritið dregst aftur úr klasastillingunni'
    },
    staleChip: 'Gögn ekki uppfærð',
    staleAsOf: 'síðasta speglun {time}',
    zone: {
      nodes: 'Hnútar',
      failoverReserve: 'Failover-forði',
      capacity: 'Rýmd',
      workload: 'Vinnuálag',
      protection: 'Vernd',
      activity: 'Nýleg virkni'
    },

    // La zona riserva di failover (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Forðinn heill',
        eroded: 'Forðinn næstum uppurinn',
        exhausted: 'Forðinn uppurinn',
        unknown: 'Forðinn óþekktur'
      },
      tolerate: {
        one: 'þolir missi {n} hnúts',
        other: 'þolir missi {n} hnúta'
      },
      usedOf: '{used} / {allowed} GiB í notkun',
      keepFree: '{n} GiB haldið lausum fyrir failover',
      expendable: 'þar af {n} fórnanleg í rekstri',
      headroom: 'enn er hægt að ræsa {n} GiB',
      short: 'forðann vantar {n} GiB — nýjar VM geta ekki ræst',

      // Pagine enormi per taglia (ratifica 2026-08-04) — forma «etichetta:
      // {n}» apposta: nessuna lingua deve declinare dopo un numero variabile.
      hp: {
        usedOf: 'Síður af stærð {size} — í notkun: {used} / {allowed}',
        keepFree: 'haldið lausum fyrir failover: {keep}',
        headroom: 'enn ræsanlegar: {n}',
        short: 'vantar í forðann: {n} — nýjar VM með risasíðum geta ekki ræst'
      },
      worstCase: 'versta tilfelli: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Enginn hnútur hefur enn gefið upp minni sitt — forðinn er ekki reiknanlegur og engri ræsingu er hafnað.',
      reason: {
        attestedDown: 'staðfestur slökktur',
        maintenance: 'í viðhaldi',
        unreachable: 'ónáanlegur',
        capacityUnknown: 'minni ekki gefið upp'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} kjarnar / {threads} þræðir',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} virk VM',
        other: '{n} virkar VM'
      },
      activeVmsUnknown: 'virkar VM óþekktar',
      lastSeen: 'sást {time}',
      neverSeen: 'aldrei sést',
      down: 'Slökktur',
      maintenance: 'Viðhald',
      stale: 'Ónáanlegur'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB úthlutaðir',
      reserve: 'forði {n} GiB',
      unobserved: 'rýmd ekki enn athuguð',
      empty: 'Engin geymsla enn'
    },
    workload: {
      vms: 'Sýndarvélar',
      apps: 'Öpp',
      services: 'Netþjónustur',
      empty: 'Enn ekkert',
      phasesUnknown: 'skipting eftir fasa ekki tiltæk'
    },
    protection: {
      none: 'Enginn áfangastaður afritunar stilltur — verndaðu stillingarnar þínar.',
      configure: 'Stilla checkpoint',
      noRuns: 'Ekkert checkpoint hefur enn verið búið til.',
      last: 'Síðasta checkpoint',
      onTarget: 'á {target}',
      viewAll: 'Checkpoint'
    },
    activity: {
      empty: 'Engin nýleg virkni',
      failed24: {
        one: '{n} mistókst á 24 klst.',
        other: '{n} mistókust á 24 klst.'
      },
      viewAll: 'Sjá öll verk'
    }
  },
  notes: {
    title: 'Minnispunktar',
    tabEdit: 'Breyta',
    tabPreview: 'Forskoðun',
    placeholder: 'Frjálsir minnispunktar rekstraraðilans — Markdown birtist í forskoðuninni',
    empty: 'Engir minnispunktar',
    tooLarge: 'Minnispunktarnir fara yfir 64 KiB mörkin',
    saveError: 'Ekki tókst að vista minnispunktana'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Svar bakendans inniheldur gildi sem þetta viðmót þekkir ekki: {field}={value} — uppfærðu webui í útgáfu bakendans.',
    contractErrorItems: '{count} hlutir í þessum lista eru ekki læsilegir fyrir þetta viðmót ({field}={value}) og eru ekki sýndir.',
    staleHint: 'Ekki næst í gagnageymsluna — þetta er stillingaspeglun þessa hnúts; staða flotans er óþekkt.',
    staleStateAge: 'staða frá {time}',
    staleStateNever: 'staða hefur aldrei borist frá gagnageymslunni: þú sérð aðeins athuganir þessa hnúts',
    staleStateTooltip: 'Ekki næst í gagnageymslu klasans: athuguð staða (fasi, hnútur, agent) kemur úr stöðuspeglun þessa hnúts og er frá síðasta heppnaða lestri úr gagnageymslunni — hún gæti verið úrelt.',
    noPermission: 'Þú hefur ekki heimild til þessarar aðgerðar',

    // Un budget di attesa scaduto NON è un esito (Luca 2026-08-06): il
    // cronometro del client misura la pazienza del client, non lo stato del
    // server — l'avviso dice «ancora in corso», mai «non riuscita».
    actionStillRunning: 'Aðgerðin er enn í gangi: niðurstaðan er ekki enn þekkt',
    staleWrite: 'Einhver annar breytti þessum hlut á meðan þú varst að breyta honum — ekkert var skrifað. Endurhladdu og endurtaktu breytinguna á nýjustu stöðunni.',
    staleReload: 'Endurhlaða',
    preview: 'Forskoðun',
    previewTitle: 'Forskoðun niðurstöðunnar',
    previewNothingWritten: 'Hermt á þjóninum — ekkert var skrifað.',
    previewChanged: 'Auðkennt: gildin sem myndu breytast.'
  },
  context: {
    copySelection: 'Afrita valinn texta'
  },
  crud: {
    create: 'Búa til',
    viewDetails: 'Sjá nánar',
    viewOrEdit: 'Sjá eða breyta',
    selected: 'valin',
    viewUsingVms: 'Sjá VM sem nota auðlindina',
    clearSelection: 'Afvelja',
    deleteSelected: 'Eyða völdum',
    bulkConfirmBody: {
      one: 'Eyða {count} völdu atriði? Sé það varið verður það tilkynnt og því haldið.',
      other: 'Eyða {count} völdum atriðum? Þau sem eru varin verða tilkynnt og þeim haldið.'
    },
    bulkDeleted: 'eytt',
    bulkRefused: 'hafnað',
    fieldId: 'ID',
    createdAt: 'Búið til þann',
    updatedAt: 'Uppfært þann',
    immutableField: 'Fest við stofnun — contract leyfir ekki að þessu sé breytt',
    immutableScope: 'Scope er úthlutað við stofnun; sumar auðlindir eru fluttar með sérstakri aðgerð',
    observedField: 'Athugað ástand — tilkynnt af vettvanginum, ekki breytanlegt'
  }
}
